<template>
  <div>
    <login-header v-bind="headerInfo" @listenToChildEvent="showMsgFromChild"></login-header>
    <div class="select-shop">
      <div class="select-top clearfix">
        <div class="select-nav">
          <label>筛选：</label>
          <p v-for="(menu,index) in store_types" @click="choose(index)" :key="index">
            <span :class="{'active':activeId==index}" data-id="0" v-text="menu.name"></span>
          </p>
        </div>
        <div class="new-create" @click="chooseStore" style="cursor: pointer" v-show="is_create">创建店铺</div>
      </div>
      <div class="shop-list" v-loading="loading">
        <ul>
          <li v-for="(item,index) in store" :key="index">
            <span class="shop-box" @click="gotoDashbord(index)">
              <div class="store-label">
                <img v-if="item.is_dp_senior" class="store-label__dp-senior" src="../../assets/img/dp-senior.png">
                <img v-else-if="item.is_dp_exclusive" class="store-label__dp-exclusive" src="../../assets/img/dp-exclusive.png">
                <img v-else-if="item.is_dp_flagship" class="store-label__dp-flagship" src="../../assets/img/dp-flagship.png">
              </div>
              <div class="bind-status-wrapper">
                <img v-if="item.app_auth_list.is_alipay" class="bind-status-icon" src="../../assets/img/icon-alipay.png">
                <img v-if="item.app_auth_list.is_wechat" class="bind-status-icon" src="../../assets/img/icon-wechat.png">
                <img v-if="item.app_auth_list.is_unionpay" class="bind-status-icon" src="../../assets/img/icon-yunshanfu.png">
              </div>
              <div class="shop-name" v-text="item.name"></div>
              <div class="shop-label" :class="[item.colors]" v-text="item.typeName"></div>
              <div class="shop-time">店铺状态：{{item.service_status}}</div>
            </span>
          </li>
        </ul>
        <div v-if="store.length==0" class="nostore" v-cloak><img src="../../assets/img/nostore.jpg" width="129" height="127">
        </div>
      </div>
    </div>
    <login-footer :description="desc"></login-footer>
  </div>
</template>
<script>
import loginHeader from '../header'
import loginFooter from '../footer'
import qs from 'qs'
export default {
  name: 'index',
  components: {
    loginHeader,
    loginFooter
  },
  data() {
    return {
      loading: true,
      headerInfo: {
        type: '选择店铺',
        userDisplayFlag: true,
        userName: '',
        logo: ''
      },
      desc: '',
      store_types: [],
      stores: [],
      activeId: 1,
      store: [],
      is_create: 0// 创建店铺按钮
    }
  },
  methods: {
    showMsgFromChild(data, loadingData) {
      var that = this
      that.loading = loadingData
      setTimeout(() => {
        that.loading = false
        that.headerInfo.userDisplayFlag = data
        localStorage.setItem('mobile', '')
        localStorage.setItem('mytoken', '')
        that.$router.push({ path: `/login.html` })
      }, 500)
    },
    chooseStore() {
      var that = this
      that.loading = true
      that.$router.push({ path: `/guide.html` })
      that.loading = false
    },
    gotoDashbord(index) {
      var that = this
      QM.apinew({
        url: '/seller/store/select',
        method: 'post',
        data: {
          store_id: this.store[index].id
        },
        success: function (xdata) {
          that.loading = true
          window.location.href = '//' + xdata.data.url
          that.loading = false
        },
        error: function (xdata) {
          that.$message.error(xdata.message)
        }
      })
    },
    choose(index) {
      var that = this
      that.activeId = index
      that.store = []
      if (index == 0) {
        that.store = that.stores
      } else {
        for (var i = 0; i < that.stores.length; i++) {
          if (that.stores[i].store_type == that.store_types[index].id) {
            that.stores[i].colors = that.store_types[index].colors
            that.stores[i].typeName = that.store_types[index].name
            that.store.push(that.stores[i])
          }
        }
      }
    }
  },

  created() {
    var that = this
    this.loginInfo = qs.parse(localStorage.getItem('xdata'))
    this.headerInfo.logo = this.loginInfo.logo
    this.desc = this.loginInfo.desc
    var temp = []
    document.title = localStorage.getItem('title')
    var mobile = localStorage.getItem('mobile')
    this.headerInfo.userName = mobile
    that.loading = true

    setTimeout(() => {
      QM.apinew({
        url: '/seller/store/index',
        method: 'get',
        success: function (xdata) {
          that.loading = false
          that.is_create = xdata.data.is_create
          that.store_types.push({ name: '所有店铺', id: 0 })
          for (var k in xdata.data.store_types) {
            that.store_types.push(xdata.data.store_types[k])
          }
          // that.stores=xdata.data.stores
          temp = xdata.data.stores
          const targetService = services => {
            return name => services.findIndex(item => item.class_name === name && item.expired_at > Date.parse(new Date()) / 1000) !== -1
          }
          for (var i = 0; i < temp.length; i++) {
            temp[i].index = temp[i].store_type
            // 判断对应服务是否开通
            const isOpenService = targetService(temp[i].services)
            if (isOpenService('Retail')) {
              temp[i].is_dp_flagship = true
            } else if (isOpenService('PlusPro')) {
              temp[i].is_dp_senior = true
            } else if (isOpenService('PlusCatering')) {
              temp[i].is_dp_exclusive = true
            }
          }
          for (var x = 0; x < temp.length; x++) {
            for (var y = 0; y < that.store_types.length; y++) {
              if (temp[x].index == that.store_types[y].id) {
                temp[x].colors = that.store_types[y].colors
                temp[x].typeName = that.store_types[y].name
              }
            }
          }

          that.stores = temp
          that.choose(0)
        },
        error: function (xdata) {
          that.loading = false
          // 如果登录超时重新跳转到登录页面
          if (xdata.code == '9001') {
            that.$router.push({ path: 'login' })
            // localStorage.clear(); //登录超时清除所有本地存储
          }
          // 登录超时报错
          // that.$message.error(xdata.message);
          //  if(timeout.cod != 9001||timeout.code != 9002){
          //     this.$message.error(timeout.message);
          //   }else{
          //     that.$message.error("退出成功");
          //   }
        }
      })
    })
  }
}
</script>

<style scoped>
  .select-nav {
    overflow: hidden;
  }

  .select-nav p {
    float: left;
  }

  .shop-list li {
    cursor: pointer;
  }

  .nostore {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 300px;
  }

  .shop-box {
    position: relative;
  }

  .bind-status-wrapper {
    position: absolute;
    right: 10px;
    bottom: 10px;
  }

  .bind-status-icon {
    width: 20px;
    height: 20px;
  }

  [v-cloak] {
    display: none;
  }
  
  .store-label {
    position: absolute;
    top: -2px;
    right: -2px;
    font-size: 0;
  }
  .store-label__dp-senior, .store-label__dp-exclusive, .store-label__dp-flagship {
    width: 83px;
    height: 30px;
    margin: 0;
  }
</style>